import React from 'react';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';

import { SpeechArticulationPhonology } from './SpeechArticulationPhonology';
import { SpeechLanguage } from './SpeechLanguage';
import { SpeechOralPeripheralFeeding } from './SpeechOralPeripheralFeeding';
import { SpeechClinicalObservations } from './SpeechClinicalObservations';
import { SpeechVoice } from './SpeechVoice';
import { SpeechSwallowing } from './SpeechSwallowing';
import { SpeechReceptiveLanguage } from './SpeechReceptiveLanguage';
import { SpeechExpressiveLanguage } from './SpeechExpressiveLanguage';
import { SpeechFluency } from './SpeechFluency';
import { SpeechCognitiveLinguistics } from './SpeechCognitiveLinguistics';
import { SpeechPragmatics } from './SpeechPragmatics';
import { SpeechOralPeripheralExam } from './SpeechOralPeripheralExam';
import { SpeechVoiceMotor } from './SpeechVoiceMotor';

class PatientCareCenterNoteObjectiveSpeechTemplate extends React.Component {
    render() {
            return (
                
                <PatientCareCenterNoteSection id='obj_speech' name='Speech' level={1}>
                   <PatientCareCenterNoteSection id='obj_speech_obs' name='Observations' level={2}>
                   <PatientCareCenterNoteSection id='obj_speech_art_pho' name='Articulation / Phonology' level={3}>
                <SpeechArticulationPhonology />
                </PatientCareCenterNoteSection>
                
                <PatientCareCenterNoteSection id='obj_speech_lang' name='Language' level={3}>
                    <SpeechLanguage />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_oral_feeding_exam' name='Oral Peripheral Exam and Feeding' level={3}>
                    <SpeechOralPeripheralFeeding />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_voice' name='Voice' level={3}>
                    <SpeechVoice />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_clinical_obs' name='Clinical Observations' level={3}>
                    <SpeechClinicalObservations />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_swallowing' name='Swallowing' level={3}>
                    <SpeechSwallowing />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_fluency' name='Fluency' level={3}>
                    <SpeechFluency />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_receptive_lang' name='Receptive Language' level={3}>
                    <SpeechReceptiveLanguage />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_expressive_lang' name='Expressive Language' level={3}>
                    <SpeechExpressiveLanguage />
                  </PatientCareCenterNoteSection>
                  
                  
                  <PatientCareCenterNoteSection id='obj_pragmatics' name='Pragmatics' level={3}>
                    <SpeechPragmatics />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_cognitive_lang' name='Cognitive Linguistics' level={3}>
                    <SpeechCognitiveLinguistics />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_oral_peri_exam' name='Speech Oral Peripheral Exam' level={3}>
                    <SpeechOralPeripheralExam />
                  </PatientCareCenterNoteSection>

                  <PatientCareCenterNoteSection id='obj_voice_motor' name='Speech Voice Motor' level={3}>
                    <SpeechVoiceMotor />
                  </PatientCareCenterNoteSection>

                 </PatientCareCenterNoteSection>
                </PatientCareCenterNoteSection>
            );
      
    }

}
export { PatientCareCenterNoteObjectiveSpeechTemplate };

